




import { Vue, Component,Prop } from 'vue-property-decorator';
import VIcon from '@/components/Common/VIcon.vue';

@Component({
  components: {
    VIcon
  }
})
export default class Spinner extends Vue {
  @Prop({default: 'md'}) readonly size!: string;

}
